module.exports = __webpack_public_path__ + "static/media/homem_r1_c6.433a4810.jpg";